import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useHistory } from "react-router-dom";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ListAdminButtons from "../Common/ListAdminButtons";
import * as dateHelper from "../../Helpers/DateHelper";
import Tooltip from "../../Components/Common/Tooltip";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import SpinnerLoading from "../Common/SpinnerLoading";
import { roles } from "../../Config/Roles";

const PosTab = ({ url }) => {
  const { t: translator } = useTranslation();
  const { roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;
  const { updateLocTab, locTab, isMobile } = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (locTab === "devices") {
      setIsLoading(true);
      axios
        .get(`${url}`)
        .then(res => {
          setData(res.data);
          setIsLoading(false);
        })
        .catch(err => console.log(err.response));
    }
  }, [locTab]);

  const { SearchBar } = Search;
  const columns = [
    {
      dataField: "inventoryNumber",
      text: translator("ICT-number"),
      sort: true,
    },
    
    {
      dataField: "posserialNumber",
      text: translator("POS-List-TableHeader-SerialNumber"),
      sort: true,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "tag",
      text: translator("POS-List-TableHeader-Tag"),
      sort: true,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "tid",
      text: translator("Tid"),
      sort: true,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "documentNumber",
      text: translator("POS-New_EditPOS-DocumentNumber"),
      sort: true,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "activationDate",
      text: translator("POS-List-TableHeader-ActivationDate"),
      formatter: dateFormatter,
      sort: true,
      hidden: Boolean(isMobile),
    },

    // {
    //   dataField: "subscriptionValidTo",
    //   text: translator("POS-List-TableHeader-ValidTo"),
    //   formatter: dateFormatter,
    //   sort: true,
    //   hidden: Boolean(isMobile),
    // },
  ];

  const handleToAdd = () => {
    history.push("/add-pos");
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      updateLocTab("products");
      history.push(`/pos/${row.posid}`);
    },
  };

  function dateFormatter(cell, rows) {
    return dateHelper.formatUtcToDate(cell);
  }

  function rowStyleSuspended(row, rowIdx) {
    return {
      backgroundColor: row.isSuspended ? "#fcaeae" : "inherit",
    };
  }

  const options = { custom: true, totalSize: data.length, sizePerPage: 5 };

  return (
    <div className="p-2">
      <div className="container-fluid p-0">
        <div className="card-body pl-0 mb-4">
          <ToolkitProvider
            keyField="posId"
            data={data}
            columns={columns}
            search>
            {props => (
              <div>
                <SearchBar
                  placeholder={translator("Pos-Tab-Search")}
                  {...props.searchProps}
                />{" "}
                <Tooltip text={translator("Tabs-Search")} />
                <ListAdminButtons
                  handleToAdd={
                    [master, admin, support].includes(Number(roleId))
                      ? handleToAdd
                      : null
                  }
                />
                <PaginationProvider pagination={paginationFactory(options)}>
                  {({ paginationProps, paginationTableProps }) => (
                    <div>
                      {isLoading && (
                        <div className="dashboard-card-spinner">
                          <SpinnerLoading />
                        </div>
                      )}
                      {!isLoading && (
                        <BootstrapTable
                          keyField="posId"
                          data={data}
                          loading
                          columns={columns}
                          rowEvents={rowEvents}
                          rowStyle={rowStyleSuspended}
                          classes={"table-sm"}
                          rowClasses="boostrap-table-row"
                          noDataIndication={translator("No-Data")}
                          {...paginationTableProps}
                          {...props.baseProps}
                        />
                      )}

                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  )}
                </PaginationProvider>
              </div>
            )}
          </ToolkitProvider>
        </div>
      </div>
    </div>
  );
};

export default PosTab;
